export default {
  badge: 'Huy hiệu',
  close: 'Đóng',
  dataIterator: {
    noResultsText: 'Không tìm thấy dữ liệu phù hợp',
    loadingText: 'Đang tải dữ liệu...',
  },
  dataTable: {
    itemsPerPageText: 'Số dòng trên trang:',
    ariaLabel: {
      sortDescending: 'Sắp xếp giảm dần.',
      sortAscending: 'Sắp xếp tăng dần.',
      sortNone: 'Không sắp xếp.',
      activateNone: 'Kích hoạt để bỏ sắp xếp.',
      activateDescending: 'Kích hoạt để sắp xếp giảm dần.',
      activateAscending: 'Kích hoạt để sắp xếp tăng dần.',
    },
    sortBy: 'Sắp xếp theo',
  },
  dataFooter: {
    itemsPerPageText: 'Số dòng hiển thị:',
    itemsPerPageAll: 'Tất cả',
    nextPage: 'Trang sau',
    prevPage: 'Trang trước',
    firstPage: 'Trang đầu',
    lastPage: 'Trang cuối',
    pageText: '{0}-{1} trên {2}',
  },
  datePicker: {
    itemsSelected: 'Đã chọn {0}',
    nextMonthAriaLabel: 'Tháng sau',
    nextYearAriaLabel: 'Năm sau',
    prevMonthAriaLabel: 'Tháng trước',
    prevYearAriaLabel: 'Năm trước',
  },
  noDataText: 'Không có dữ liệu',
  carousel: {
    prev: 'Trước',
    next: 'Sau',
    ariaLabel: {
      delimiter: 'Slide {0} trên {1}',
    },
  },
  calendar: {
    moreEvents: 'Còn {0}',
  },
  fileInput: {
    counter: '{0} tệp tin',
    counterSize: '{0} tệp tin ({1} trong tất cả)',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
  },
  pagination: {
    ariaLabel: {
      wrapper: 'Chuyển trang',
      next: 'Trang sau',
      previous: 'Trang trước',
      page: 'Đến trang {0}',
      currentPage: 'Trang hiện tại, trang {0}',
    },
  },
}